import { Component, Inject, Input, Optional } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { ValueAccessorBase } from 'app/shared/input/value-accessor-base';

@Component({
  selector: 'cbm-input-text',
  templateUrl: './cbm-input-text.component.html',
  styleUrls: ['./cbm-input-text.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CbmInputTextComponent, multi: true }]
})
export class CbmInputTextComponent extends ValueAccessorBase<string> {
  @Input() id: string;
  @Input() label: string;
  @Input() inputStyle: CbmInputStyle;
  @Input() disabled?: boolean;
  @Input() type = 'text';
  @Input() tooltip?: string;

  constructor(@Optional() @Inject(NG_VALIDATORS) private readonly validators: any[]) {
    super(); // ValueAccessor base
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input/cbm-input-text/cbm-input-text.component.ts